<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>THE STORY DEVOTIONAL</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ct1p" id="p0010-01-0a"><a id="page5"></a><a href="#/contents#fn_4" id="sn_4">DAY 4</a></p>
<p class="ct1"><a href="#/contents#fn_4">AN INTELLIGENT DESIGN</a></p>
<p class="ext"><span><i>God created the great creatures of the sea and every living thing with which the water teems and that moves about in it, according to their kinds, and every winged bird according to its kind. And God saw that it was good.</i></span></p>
<p class="txr"><span><span class="small">GENESIS</span> 1:21</span></p>
<p class="tx1" id="p0011-04-4"><span class="dcap">I</span>f a pocket watch washed up on shore and was discovered by people who had never seen one before, what might their reactions be after they inspected the moving second hand and its inner workings? Would anyone consider it an amazing result of pure chance? Would anyone suggest that all the materials coincidentally came together in the perfect size, shape, and organization and, once all was in place, the watch started to work? Doubtful, isn’t it? The very existence of the pocket watch suggests the existence of a Creator.</p>
<p class="tx">Individuals today look around at God’s amazing creation and don’t see (or don’t <i>let</i> themselves see) that there must be a Creator behind it all. Each one of the variety of creatures living in the skies and in the oceans eats, breathes, and reproduces . . . by chance?</p>
<p class="tx">We human beings are without excuse: every aspect of creation points to our Creator-God!</p>
<p class="tx3">MAY GOD’S AMAZING CREATION PROMPT US TO PRAISE HIM!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter7.vue?949b00b4